import { QueryString, isPlainObject } from '@grandvisionhq/utils';
import { EmptyConsent } from '../types.js';

const OneTrustConsentMap = {
    C0001: 'required',
    C0002: 'analytics',
    C0003: 'functional',
    C0004: 'marketing',
    C0005: 'social'
};
const isCookieCategoryEnabled = (category, consentResult)=>consentResult ? consentResult.has(category) : false
;
const isOneTrustCookie = (data)=>isPlainObject(data) && 'groups' in data
;
function getConsentResult(cookies) {
    const consentRawData = (cookies === null || cookies === void 0 ? void 0 : cookies.OptanonConsent) || '';
    if (!consentRawData) {
        return EmptyConsent;
    }
    const parsedValues = QueryString.parse(consentRawData);
    if (!isOneTrustCookie(parsedValues)) {
        return EmptyConsent;
    }
    return new Set(parsedValues.groups.split(',') // => [ 'C0001:1', 'C0002:0', ... ]
    .map((pair)=>pair.split(':')
    ) // => [ ['C0001', '1'], ['C0002', '0'], ... ]
    .filter(([, value])=>+value
    ) // => [ ['C0001', '1'], ... ]
    .map(([key])=>OneTrustConsentMap[key]
    ) // => [ 'required', ... ]
    );
}
const OneTrustProvider = (cookies)=>{
    return getConsentResult(cookies);
};

export { OneTrustProvider, isCookieCategoryEnabled };
//# sourceMappingURL=onetrust-provider.js.map
